import * as angular from 'angular';
import datacatalog from '../integration/datacatalog/datacatalog-services';
import {FeatureByTypeId} from "./model-featurelist";
import {Feature} from "../integration/representation/feature";
import {Destination} from "../integration/representation/contract";

export default class FeatureListSummary {
    private counter: Counter;
    private count: number;
    constructor(public features: FeatureByTypeId, datacatalog: datacatalog, destination: Destination) {
        this.counter = new Counter(datacatalog);
        angular.forEach(features, function(feature: Feature[], typeId: number) {
            this.counter.inc(typeId, feature.length, this.counter.calculateLength(feature), destination);
        }.bind(this));

        this.count = this.counter.count;
        this.features = Object.keys(this.counter.features).map(function(featureTypeId: number) {
            return this.counter.features[featureTypeId];
        }.bind(this));
    }
}

class Counter {
    constructor(private readonly datacatalog: datacatalog,
                public count = 0,
                public features: { [key: number]: FeatureCounter } = {}){
    }

    inc(featureType: number, numberOfFeatures: number, totalGeometryLength: number, destination: Destination) {
        let featureCounter = this.features[featureType];
        if (!featureCounter) {
            featureCounter = new FeatureCounter(this.datacatalog, featureType, destination);
            this.features[featureType] = featureCounter;
        }
        featureCounter.inc(numberOfFeatures, totalGeometryLength);
    }

    calculateLength(feature: Feature[]) {
        return feature.reduce(function(sum, f) {
            return sum + f.geometry.length;
        }, 0);
    }
}

class FeatureCounter {
    private name: string;
    private sortNum: number;
    private count = 0;
    private geometryLength = 0;

    constructor(datacatalog: datacatalog,
                featureType: number,
                destination: Destination) {
        this.name = datacatalog.getFeatureTypeName(featureType, destination);
        this.sortNum = datacatalog.getFeatureTypeSortNum(featureType);
    }

    inc(numberOfFeatures: number, geometryLength: number): void {
        this.count += numberOfFeatures;
        this.geometryLength += geometryLength;
    }

}
